import { logWarn } from '@ardoq/logging';
import { LayoutBoxModel, NavigatorLayoutState } from '../types';
import { getHiddenNodes, layout } from '../models/layout';
import { DEFAULT_SCROLL_TOP_MARGIN, HEIGHT_COMPONENT_ITEM } from './consts';

export const scrollSelectedNodeIntoViewIfNeeded = (
  state: NavigatorLayoutState
) => {
  const { container, tree } = state;
  if (!(container && tree.selectedContext)) {
    return;
  }
  const selectedId = tree.selectedContext.id;
  scrollNodeIntoViewIfNeeded(state, selectedId);
};

export const scrollNodeIntoViewIfNeeded = (
  {
    height,
    scrollTop,
    container,
    showFilteredComponents,
    tree,
  }: NavigatorLayoutState,
  selectedId: string
) => {
  if (!container) {
    return;
  }
  const hiddenNodes = getHiddenNodes(tree, showFilteredComponents);
  const hiddenNodeIds = new Set<string>(
    [...hiddenNodes.values()].map(({ id }) => id)
  );
  if (hiddenNodeIds.has(selectedId)) {
    return;
  }
  const layoutBox = layout(
    tree,
    height,
    scrollTop,
    new Set([selectedId]),
    undefined,
    showFilteredComponents,
    hiddenNodes
  );

  const selectedLayoutBox = layoutBox.layoutMap.get(selectedId);
  if (!selectedLayoutBox) {
    logWarn(
      Error('Missing layoutBox in scrollToNodeIfHidden in navigationManager')
    );
    return;
  }
  if (!isVisible(selectedLayoutBox, container)) {
    container.scrollTop =
      selectedLayoutBox.top - getDelta(container.clientHeight);
  }
};

const getDelta = (containerHeight: number) => {
  if (
    containerHeight >
    HEIGHT_COMPONENT_ITEM + 1.2 * DEFAULT_SCROLL_TOP_MARGIN
  ) {
    return DEFAULT_SCROLL_TOP_MARGIN;
  }

  return (containerHeight - HEIGHT_COMPONENT_ITEM) / 2;
};

const isVisible = (layoutBox: LayoutBoxModel, container: HTMLElement) => {
  const { height } = container.getBoundingClientRect();
  const { scrollTop } = container;
  return layoutBox.top >= scrollTop && layoutBox.bottom <= scrollTop + height;
};
